import { render } from "./MemberPortalNavigation.vue?vue&type=template&id=e9da2f52&scoped=true"
import script from "./MemberPortalNavigation.vue?vue&type=script&lang=js"
export * from "./MemberPortalNavigation.vue?vue&type=script&lang=js"

import "./MemberPortalNavigation.vue?vue&type=style&index=0&id=e9da2f52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9da2f52"]])

export default __exports__